import { divide } from './decimal';

const calcSecondsToDate = (date?: string | null): number => {
  if (!date) {
    return 0;
  }
  const futureDate = new Date(date).getTime();
  const currentDate = new Date().getTime();
  const differenceInMiliseconds = futureDate - currentDate;

  return differenceInMiliseconds >= 0
    ? Math.ceil(divide(differenceInMiliseconds, 1000))
    : 0;
};

const calcTimeToEnableSell = (): number => {
  const lastSellTimeIso = localStorage.getItem('lastSellTime');

  if (!lastSellTimeIso) {
    return 0;
  }

  const lastSellTime = new Date(lastSellTimeIso).getTime();
  const nextTimeToEnableSell = lastSellTime + 10 * 1000;

  return calcSecondsToDate(new Date(nextTimeToEnableSell).toISOString());
};

export { calcSecondsToDate, calcTimeToEnableSell };
